import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { UrlService } from '@core/services/url/url.service';

import * as Objects from '@core/objects';

@Injectable({
    providedIn: 'root'
})
export class SettingsWorkflowsRequests {
    constructor(private http: HttpClient, private urlSrv : UrlService) {};


    public loadWorkflows$ = () : Observable<Objects.Workflow[]> =>
        this.http.get<Objects.Workflow[]>(this.urlSrv.build("/workflows"),{params: {all: 'true'}});

    
    public loadWorkflowTransitions$ = (id: number) : Observable<Objects.WorkflowTransition[]> =>
        this.http.get<Objects.WorkflowTransition[]>(this.urlSrv.build("/workflows/" + id + "/transitions"),{params: {all: 'true'}});

        /**
         * TODO: manage workflow model
         * @transitions is not an object WorkflowTransition, it is an interface WorkflowEditorOutput 
         */
    public save$ = (transitions, id: number) : Observable<Objects.WorkflowTransition[]> =>
        this.http.post<Objects.WorkflowTransition[]>(this.urlSrv.build("/workflows/" + id + "/transitions"), transitions, { headers: new HttpHeaders({ 'Content-Type':  'application/json'}) });
}
